<template>
  <div class="container">
    <div class="columns">
      <div class="column box is-three-fifths is-offset-one-fifth content">
        <div class="section content">
          <span v-html="text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var showdown  = require('showdown');
export default {
  name: 'Maintenance',
  data() {
    return { text: '' };
  },
  beforeMount() {
    var converter = new showdown.Converter();
    this.text = converter.makeHtml(this.$store.state.maintenanceResponse);
  },
};
</script>

<style lang="scss" scoped>
</style>